export default "__VITE_ASSET__Do2TQVg1__"